import { alertVariants } from "@visiblethread/react-components";

import localhost from "../../../apis/localhost";
import { showErrorModal } from "../../app/actions/error";
import { showGlobalAlert } from "../../app/appSlice";
import {
  selectAllowedSitesDraft,
  selectAllowedSitesPolicy,
} from "../allowedSitesSelectors";
import {
  setAllowedSitesConflict,
  setAllowedSitesPolicy,
  setAllowedSitesReauthenticationRequired,
  setAllowedSitesSaveError,
  setAllowedSitesSaving,
} from "../allowedSitesSlice";
import {
  AUTH_REQUIRED,
  POLICY_CHANGED,
  REQUEST_CONFIG,
  SAVE_FAILED,
} from "./allowedSitesConstants";
import {
  allowedSitesUrl,
  errorCodeOf,
  messageOf,
  redirectUnlessSharepointError,
} from "./allowedSitesUtils";

export const saveAllowedSites =
  ({ isCloudMode }) =>
  async (dispatch, getState) => {
    const policy = selectAllowedSitesPolicy(getState());
    const draft = selectAllowedSitesDraft(getState());
    dispatch(setAllowedSitesSaving(true));
    dispatch(setAllowedSitesSaveError(null));
    try {
      const { data } = await localhost.put(
        allowedSitesUrl(isCloudMode),
        {
          expectedRevision: policy.revision,
          restricted: draft.restricted,
          siteIds: draft.sites.map((site) => site.id),
        },
        REQUEST_CONFIG
      );
      dispatch(setAllowedSitesPolicy(data));
      dispatch(
        showGlobalAlert({
          variant: alertVariants.success,
          text: "Allowed sites saved successfully",
        })
      );
      return true;
    } catch (error) {
      redirectUnlessSharepointError(error);
      const errorCode = errorCodeOf(error);
      if (errorCode === POLICY_CHANGED) {
        dispatch(setAllowedSitesConflict(true));
      }
      if (errorCode === AUTH_REQUIRED) {
        dispatch(setAllowedSitesReauthenticationRequired());
      }
      if (errorCode) {
        dispatch(
          setAllowedSitesSaveError({
            errorCode,
            message: messageOf(error, SAVE_FAILED),
          })
        );
      } else {
        dispatch(showErrorModal({ message: SAVE_FAILED }, "Allowed Sites"));
      }
      return false;
    } finally {
      dispatch(setAllowedSitesSaving(false));
    }
  };
